// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/online-payment-schema',
  type: 'object',
  required: ['amount'],
  properties: {
    transactionId: {
      type: 'string',
      nullable: true,
    },
    paymentDate: {
      type: 'string',
      format: 'date-time',
    },
    currency: {
      type: 'string',
      nullable: true,
    },
    amount: {
      type: 'number',
    },
    paymentType: {
      enum: [
        0,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
      ],
    },
    onlinePaymentMethodRaw: {
      type: 'string',
      nullable: true,
    },
    onlinePaymentBrandCodeRaw: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
